import { render } from "./TransactionLogEdit.vue?vue&type=template&id=1f53aba0"
import script from "./TransactionLogEdit.vue?vue&type=script&lang=js"
export * from "./TransactionLogEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__